import axios from 'axios';
import { appConfig } from '../../app-config';

export const donationApi = async (data) => {
  const endpoint = `${appConfig.API_URL}/api/payment/create`;
  try {
      const response = await axios.post(`${endpoint}`, data);
      return response;

    } catch (error) {
      return error;
    }
}
export const rewardApplyApi = async (data) => {

  const endpoint = `${appConfig.API_URL}/api/payment/givecard`;
  try {
      const response = await axios.post(`${endpoint}`, data);
      return response;

    } catch (error) {
      return error;
    }
}
export const redeemGivecardApi = async (data) => {

  const endpoint = `${appConfig.API_URL}/api/payment/givecard/redeem`;
  try {
      const response = await axios.post(`${endpoint}`, data);
      return response;

    } catch (error) {
      return error;
    }
}
export const savedPayments = async (data) => {

  const axiosInstance = axios.create({
    withCredentials: true,
    headers: {
      'accept': 'application/json',
      'Content-Type': 'application/json',
      'Access-Control-Allow-Origin': origin,
      'X-Csrftoken': data?.csrfToken,
      'Referer':'https://qa.givesome.org/dashboard/saved-payments/'
    }
  });
  
  const endpoint = `${appConfig.SAVED_PAYMENT}`;
  try {
    const response = await axiosInstance.post(`${endpoint}`, {payment_method_id: data?.paymentMethodId});
    return response;

    } catch (error) {
      return error;
    }
}
export const sendIsCardSaveDetails = async (data) =>{
  const endpoint = `${appConfig.API_URL}/api/payment/paymentIntent/update`;
  try {
    const response = await axios.post(`${endpoint}`, data);
    return response;
  } catch(err) {
    return err;
  }
}
export const getCurrencyList = async (data) => {
  
  const endpoint = `${appConfig.API_URL}/api/payment/currency/list`;
  try {
      const response = await axios.get(`${endpoint}`, data);
      return response;

    } catch (error) {
      return error;
    }
}

export const getIpBasedCurrency = async (data) => {
  const endpoint = `https://ipapi.co/json/`;
  try {
      const response = await axios.get(`${endpoint}`, data);
      return response;

    } catch (error) {
      return error;
    }
}


export const createPaymentIntent = async (data) => {

  const endpoint = `${appConfig.API_URL}/api/payment/paymentIntent`;
  try {
      const response = await axios.post(`${endpoint}`, data);
      return response;

    } catch (error) {
      return error;
    }
}

export const retrievePaymentDetails = async (data) => {

  const endpoint = `${appConfig.API_URL}/api/payment/confirm`;
  try {
      const response = await axios.post(`${endpoint}`, data);
      return response;

    } catch (error) {
      return error;
    }
}
export const sendBillingDetails = async (data) => {

  const endpoint = `${appConfig.API_URL}/api/payment/billingDetails/update`;
  try {
      const response = await axios.post(`${endpoint}`, data);
      return response;

    } catch (error) {
      return error;
    }
}

export const getDenominationsList = async (data) => {

  const endpoint = `${appConfig.API_URL}/api/payment/amount`;
  try {
      const response = await axios.post(`${endpoint}`, data);
      return response;

    } catch (error) {
      return error;
    }
}